import { createSelector } from '@reduxjs/toolkit';

import { PlateManufacturer } from '@paragon/contract-library';
import { isG2User } from '@paragon/login-tools';

export const getPlateManufacturerFormatter = createSelector(
  isG2User,
  (isG2User) => (plateManufacturer: PlateManufacturer) => {
    switch (plateManufacturer) {
      case 'CH Machine':
        return isG2User ? 'G2' : 'CH Machine';

      // Plate manufacturers are already human formatted when serialized server side.
      default:
        return plateManufacturer;
    }
  },
);
